// This file contains all services
export const LOYALTY_SERVICE = 'loyalty';
export const DRIVE_SERVICE = 'drive';
export const PAYMENTS_SERVICE = 'payments';
